<div id="vod-repackaging-form" class="container cl-form" [formGroup]="poFormGroup">
  <h2 class="it-section-title pt-3 mb-5">New encode</h2>
  <!-- A Haze section as on VOD Default, edge to edge, its content in the container. -->
  <section class="cl-section cl-section-form cl-color-haze" data-po-header>
    <div class="row cl-spacing-small">
      <div class="col-6">
        <label for="projectid" class="form-label">Project ID</label>
        <input id="projectid" type="text" formControlName="po_number" pattern="[A-Za-z0-9_\.\-\/]+" [class.invalid]="poFormGroup.controls.po_number.invalid && (poFormGroup.controls.po_number.touched || poFormGroup.controls.po_number.dirty)">
        @if (poFormGroup.controls.po_number.errors?.required) {
          <p class="invalid-feedback">This field is required.</p>
        }
        @if (poFormGroup.controls.po_number.errors?.pattern) {
          <p class="invalid-feedback">Only letters, numbers and '_', '-', '/' or '.' are allowed</p>
        }
        @if (poFormGroup.controls.po_number.errors?.poNameTooLong; as tooLong) {
          <p class="invalid-feedback">The PO name "{{ tooLong.poName }}" has {{ tooLong.actual }}
            characters; the encoder accepts at most {{ tooLong.max }}.</p>
        }
        @if (poFormGroup.controls.po_number.errors?.s3TagValueTooLong; as tooLong) {
          <p class="invalid-feedback">The PO name is too long: it encodes to {{ tooLong.encoded }} of at
            most {{ tooLong.max }} characters. Characters outside <code>A-Z a-z 0-9 + - = . _ :</code>
            need three characters each when encoded.</p>
        }
        @if (!poFormGroup.controls.po_number.errors) {
          <p class="valid-feedback">The Project ID groups related encodes for easier reference and organization.</p>
        }
      </div>
      <div class="col-3">
        <label for="po_destination" class="form-label">Delivery Destination<span class="required">*</span></label>
        <select id="po_destination" class="form-select" formControlName="po_destination"
          [compareWith]="compare_destination_id" [class.invalid]="poFormGroup.controls.po_destination.invalid && (poFormGroup.controls.po_destination.touched || poFormGroup.controls.po_destination.dirty)">
          @for (sys of poDestinations; track sys) {
            <option [value]="sys.destination_id">{{ sys.display_name }}</option>
          }
        </select>
        @if (poFormGroup.controls.po_destination.errors?.required) {
          <p class="invalid-feedback">This field is required.</p>
        }
        @if (!poFormGroup.controls.po_destination.errors) {
          <p class="valid-feedback">Select the desired destination.</p>
        }
      </div>

      <div class="col-3 ">
        <label for="auto_publish" class="form-label">Publication</label>
        <select id="auto_publish" class="form-select" formControlName="auto_publish">
          <option [value]="true"> Automatic Publication
          </option>
          <option [value]="false"> Manual Publication
          </option>
        </select>
        <p class="valid-feedback">Manual Publication allows for a final QA step before distributing the content, whereas Automatic Publication releases the content immediately upon readiness.</p>
      </div>

    </div>
  </section>

  <div class="row cl-spacing-small">
    <div class="col-12">
      @if (poItems.controls.length > 0) {
        <h2 class="it-section-title">PO Items</h2>
      }
    </div>
  </div>
  <ng-container formArrayName="poItems">

    @for (item of poItems.controls ; track poItemTrackBy(idx, item); let idx = $index) {
      <ng-container [formGroup]="poItems.controls[idx]" [formGroupName]="idx"
        >
        <!-- One collapsible card per PO item, as on the other PO forms; red outline only once a submit
             was refused. -->
        <div class="row cl-spacing-small">
          <div class="col-12">
            <details class="card" open data-po-item [class.cl-color-red-outline]="submitted && poItems.controls[idx].invalid">
              <summary class="card-header">
                {{ poItems.controls[idx].value['basics']['po_item_id'] }}
                <!-- preventDefault: a click on the button must not also toggle the card. -->
                <button class="cl-btn-quickaction" type="button"
                        (click)="$event.preventDefault(); poService.removePOItem(poItems.controls[idx].value['id'])">
                  Remove item
                </button>
              </summary>
              <div class="card-body">
                <input id="idinput" type="hidden" formControlName="id">
                <app-basic-poitem-vod-info formControlName="basics" [submitted]="submitted" poItemIdLabel="Title"></app-basic-poitem-vod-info>
                <app-vod-repackaging-format-specific formControlName="format_specific_data"></app-vod-repackaging-format-specific>
              </div>
            </details>
          </div>
        </div>
      </ng-container>
    }


  </ng-container>
  <div class="row">
    <div class="col-12">

      <app-form-footer label="Start encode" icon="play" (action)="submit_po($event)"></app-form-footer>
    </div>
  </div>

</div>
